import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-data-protection',
  templateUrl: './data-protection.component.html',
  styleUrls: [
    '../../shared/Styles/public-page.css',
    './data-protection.component.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataProtectionComponent {
  public readonly sectionIds = [1, 2, 3, 4, 5, 6, 7, 8];
  public readonly paragraphIds = [1, 2];
}
